<template>
  <div class="text-nash-midnightBlue700">
    <div class="overflow-y-auto">
      <AskSOPModalInputs
        :loading="loading"
        :show-dev-tools="showDevTools"
        @submit="submitQuery"
      />
      <AskSOPModalResponse
        :response="response"
        :inputs="inputs"
        :loading="loading"
        :error="error"
        :show-dev-tools="showDevTools"
        @reset="reset"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AskSOPModalInputs from './AskSOPModalInputs/AskSOPModalInputs.vue'
import AskSOPModalResponse from './AskSOPModalResponse/AskSOPModalResponse.vue'
import setup from './controller'

export default defineComponent({
  components: {
    AskSOPModalInputs,
    AskSOPModalResponse,
  },
  props: {
    showDevTools: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['close'],
  setup,
})
</script>
